package dk.smark.demo.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: Int? = null,
    val email: String,
    val name: String
)

@Serializable
data class CreateUserRequest(
    val email: String,
    val name: String,
    val pwd: String
)

@Serializable
data class LoginRequest(
    val email: String,
    val pwd: String
)

@Serializable
data class LoginResponse(
    var id: Int? = null,
    val email: String? = null,
    val name: String? = null,
    var createdAt: String? = null
)

@Serializable
data class UpdateUserRequest(
    val email: String? = null,
    val name: String? = null
)

@Serializable
data class ChangePasswordRequest(
    @SerialName("currentPwd") val currentPwd: String,
    @SerialName("newPwd") val newPwd: String
)